import { Link } from 'react-router-dom'
import { Button, Comment, List, Tag, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { moment } from '@BUP/configs/i18n'
import { EyeOutlined } from '@ant-design/icons'
import { ComplaintInfractionLevelTag } from '@BUP/components/complaint/infraction-level-tag.jsx'
import { ComplaintStateBadgeRibbon } from '@BUP/components/complaint/state-ribbon.jsx'
import styles from './list.module.scss'
import { useContext } from 'react'
import { FilteredComplaintsContext } from '@BUP/contexts/filtered-complaints-context'

function ComplaintListItem ({ complaint }) {
  const i18n = useTranslation()
  const showLink = (
    <Link key='show' to={`/logbook/complaints/${complaint.id}`}>
      <Button type='link' icon={<EyeOutlined />}>{i18n.t('common.resources.complaint.actions.show.label')}</Button>
    </Link>
  )

  return (
    <List.Item>
      <ComplaintStateBadgeRibbon state={complaint.state}>
        <Comment
          avatar={
            <div className={styles.level_tag_wrapper}>
              <ComplaintInfractionLevelTag level={complaint.infractionLevel} />
            </div>
        }
          author={complaint.creator.user.name}
          datetime={moment(complaint.createdAt).format('D [de] MMMM [de] YYYY, HH:mm:ss')}
          content={
            <>
              <Typography.Title level={5}>{complaint.title}</Typography.Title>
              <Tag key='entries'>{i18n.t('common.resources.complaint-entry.label', { context: 'with-count', count: complaint.complaintEntries.length })}</Tag>
            </>
          }
          actions={[showLink]}
          className={styles.comment_wrapper}
        />
      </ComplaintStateBadgeRibbon>
    </List.Item>
  )
}

export const ComplaintList = ({ complaints, ...props }) => {
  const { filteredComplaints } = useContext(FilteredComplaintsContext)

  return (
    <List
      itemLayout='vertical'
      {...props}
      dataSource={filteredComplaints || complaints}
      renderItem={complaint => (
        <div className={styles.list_item}>
          <ComplaintListItem key={complaint.id} complaint={complaint} />
        </div>
      )}
      className={styles.list_container}
    />
  )
}
